import type { CosmicPurchaseOptionType } from '@/lib/cms/cosmic/types/CosmicProductType'

type Props = {
  purchaseOptions?: CosmicPurchaseOptionType[]
}

export const getDefaultSelectedPurchaseOption = ({
  purchaseOptions,
}: Props): string | null => {
  if (!purchaseOptions) return null

  // Find the default purchase option that is not disabled
  const defaultPurchaseOption = purchaseOptions.find(
    (purchaseOption) =>
      purchaseOption.isDefault === true && purchaseOption.isEnable === true,
  )

  // If no default is found and not disabled, return the first enabled option
  if (!defaultPurchaseOption) {
    const firstEnabledOption = purchaseOptions.find(
      (purchaseOption) => purchaseOption && purchaseOption.isEnable === true,
    )

    return firstEnabledOption ? firstEnabledOption.key || null : null
  }

  // Return the type of the default purchase option if available
  return defaultPurchaseOption.key || null
}
